import { NgClass } from '@angular/common';
import { booleanAttribute, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BaseInput } from './../../models';
import { prefixInput } from './../../utils';

@Component({
	selector: 'app-input-label',
	template: `
		@if (
			field.label &&
			field.inputType !== 'checkbox' &&
			field.inputType !== 'fieldset'
		) {
			<label
				[attr.for]="name"
				class="label"
				[ngClass]="{
					'fw-bold': field.required || field.inputType === 'list'
				}"
				>{{ field.label | translate }}
				@if (field.required || false) {
					<span>*</span>
				}
			</label>
		}
	`,
	standalone: true,
	imports: [NgClass, TranslateModule]
})
export class InputLabelComponent {
	@Input({ transform: prefixInput }) name: string;
	@Input() field: BaseInput;
	@Input({ transform: booleanAttribute }) filter: boolean;
}
